export const CustomFieldDataType = {
    TEXT: 'TEXT',
    AMOUNT: 'AMOUNT',
    DATE: 'DATE',
    ENUM: 'ENUM',
};
